module.exports = __webpack_public_path__ + "static/media/custom-5000-medium.0e68dd49.svg";